import { useAtom } from 'jotai'
import { useEffect } from 'react'

import { Box } from '@/components/ui/box'
import { Text } from '@/components/ui/typography'
import { grpAwardAmountAtom, grpCategoriesAtom, grpCategoryAtom } from '@/store/tasksApprovals/detailsDrawer'
import { IField } from '@/types/tasksApprovals'

import DrowpDown from './Dropdown'

const Container = ({ item }: { item: IField }) => {
    const [, setGrpAwardAmount] = useAtom<number>(grpAwardAmountAtom)
    const [, setGrpCategory] = useAtom(grpCategoryAtom)
    const [, setGrpCategories] = useAtom(grpCategoriesAtom)

    const onChange = (value: string) => {
        setGrpCategory(value)
        if (typeof item.categories !== 'undefined') {
            setGrpAwardAmount(item.categories[+item.value].min)
        }
    }

    useEffect(() => {
        setGrpCategory(item.value as string)
        if (typeof item.categories !== 'undefined') {
            setGrpCategories(item.categories)
            setGrpAwardAmount(item.categories[+item.value].min)
        }
        return () => {
            setGrpCategory('')
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Box py="8px" px="24px">
            <Text fontSize={12} pb="4px">
                {item.name}
            </Text>
            <DrowpDown options={item?.categories ? item.categories : {}} onChange={onChange} />
        </Box>
    )
}

export default Container
